import { SmartTable } from '../../../../../components/smart-table/smart-table.model';

export class Controller {

    /** @ngInject */
    constructor($state, AccountsResource, Alert) {
        this.$state = $state;
        this.AccountsResource = AccountsResource;
        this.Alert = Alert;
    }

    $onInit() {
        if (!this.selectedAccounts.length) {
            this.$state.go('^', {}, {location: 'replace'})
        }

        this.st = new SmartTable();
        this.selectedAdAccounts = this.selectedAccounts
            .filter(account => account.accountType === 'AD');
    }

    delete() {
        const accountIds = this.selectedAccounts
            .filter(({isDeletable}) => isDeletable)
            .map(({id}) => id);

        this.isSaving = true;
        this.AccountsResource
            .deleteUserAccounts(this.companyId, accountIds)
            .then(() => {
                const accounts = this.accountsForCompanyUser;
                const filteredAccounts = accounts.filter(({id}) => !accountIds.includes(id));
                accounts.splice(0, accounts.length, ...filteredAccounts);
                this.Alert('success', 'company.user-directories.manage-user.delete-accounts.deleted');

                if (accounts.length) {
                    this.$state.go('^');
                } else {
                    // When all accounts are deleted, company user is also deleted
                    this.$state.go('company.user-directories.saaspass-users');
                }
            })
            .finally(() => this.isSaving = false)
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-user/delete-accounts/delete-accounts.controller.js